<template>
    <v-form @submit.prevent="printReport" ref="form">
        <v-card style="border-radius:4px;">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">Annualization Reports</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout row wrap> 
                    <v-alert v-if="error" :value="true" color="error" icon="error" outline style="margin:10px 0px 10px 0px;">
                        Error encountered. Please contact support.
                    </v-alert> 
                    <v-flex xs12 sm12 style="padding: 0px 15px 0px 15px; ">
                        <v-select
                            label="Select report"
                            :items="report_types"
                            :rules="[rules.required]" 
                            item-text="name"
                            item-value="code"
                            v-model="reportCode"           
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap> 
                    <v-flex xs12 sm12 style="padding: 0px 15px 0px 15px; ">
                        <v-alert v-if="selected_report!=null" :value="true" color="info" icon="info" outline >
                            {{selected_report.description}}
                        </v-alert>  
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions height="45px">
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :disabled="disabled||disable2316||!reportCode" :loading="loading" style="margin-right:20px;">
                    <v-icon>fas fa-file-pdf</v-icon>&nbsp;&nbsp;&nbsp;Preview PDF
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPdfPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>
    </v-form>
</template>
<script>

import annualizationApi from '@/api/annualization'
import awsS3Helper from '@/helpers/aws-s3'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'

export default {
    components: {
        'preview': () => import('@/components/FilePreview/Preview'),
    },
    data () {
        return {
            error: false,
            errorMessage: null,
            reportCode: null,
            loading: false,
            disabled: false,
            dialogPreview: false,
            report_types: [
                {
                    code: 1, 
                    name: 'Annualization Report', 
                    description: 'Annualization data in pdf format.'
                },
                {
                    code: 2316, 
                    name: 'BIR Form No. 2316', 
                    description: 'BIR Form No. 2316 - Certificate of Compensation Payment/Tax Withheld'
                },
            ],
            rules: {
                required: value => !!value || 'Required field'
            },
            employeeName: null,
            fiscalPeriodId: null,
            selectedUserId: null,
            fiscalYear: null,
            canPrint2316: false
        }   
    },
    methods: {
        setParam(data) {
            this.$refs.form.reset()
            this.employeeName = data.employeeName
            this.fiscalPeriodId = data.fiscalPeriodId
            this.selectedUserId = data.selectedUserId
            this.fiscalYear = data.fiscalYear
            this.canPrint2316 = data.canPrint2316
        },
        printReport() {
            try {
                if (this.$refs.form.validate()) {
                    if (this.reportCode==1) this.previewAnnualization()
                    if (this.reportCode==2316) this.preview2316()
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogReports', false)
        },
        async preview2316() {
            try {
                this.loading = true 
                const response = await annualizationApi.get2316Url(this.fiscalPeriodId,this.selectedUserId)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getEmployeeDocumentUrl(this.selectedUserId, response.data.fileName, AWSS3DocumentType.BIR2316)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async previewAnnualization() {
            try {
                this.loading = true 
                const response = await annualizationApi.getPDFUrl(this.fiscalPeriodId,this.selectedUserId)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getEmployeeDocumentUrl(this.selectedUserId, response.data.fileName, AWSS3DocumentType.Annualization)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    computed: {
        selected_report() {
            if (this.reportCode!=null){
                return this.report_types.filter(x => {
                    return x.code == this.reportCode
                })[0]
            }
        },
        disable2316() {
            return this.reportCode == 2316 && !this.canPrint2316
        }
    },
    created() {}
}
</script>